/**
 * 坐标类型
 *
 * @export
 * @enum {number}
 */
export enum CoordType {
  /** 百度经纬度坐标 */
  BD09LL = 'BD09LL',
  /** 百度墨卡托坐标 */
  BD09MC = 'BD09MC',
  /** 火星坐标 */
  GCJ02 = 'GCJ02',
  /** WGS84坐标 */
  WGS84 = 'WGS84',
}
